import { injectCss } from "../../../../../../node_modules/@pebblepad/pebblepack/runtime/InjectCss.runtime.js";
injectCss(`.cui-icon-svg svg{width:100%;height:100%;overflow:visible}`);